import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("cp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  categories: () => client.get("/categories").then((r) => r.data),
  products: (params) => client.get("/products", { params }).then((r) => r.data),
  product: (slug) => client.get(`/products/${slug}`).then((r) => r.data),
  industries: () => client.get("/industries").then((r) => r.data),
  testimonials: () => client.get("/testimonials").then((r) => r.data),
  faqs: () => client.get("/faqs").then((r) => r.data),
  blog: () => client.get("/blog").then((r) => r.data),
  blogPost: (slug) => client.get(`/blog/${slug}`).then((r) => r.data),
  createQuote: (data) => client.post("/quotes", data).then((r) => r.data),
  createQuoteLead: (data) =>
    fetch(`${API}/quote-leads`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }).then((r) => {
      if (!r.ok) throw new Error(`Request failed (${r.status})`);
      return r.json();
    }),
  createEnquiry: (data) => client.post("/enquiries", data).then((r) => r.data),
  newsletter: (email) => client.post("/newsletter", { email }).then((r) => r.data),
  login: (data) => client.post("/auth/login", data).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  adminBlogCreate: (data) => client.post("/admin/blog", data).then((r) => r.data),
  adminBlogDelete: (id) => client.delete(`/admin/blog/${id}`).then((r) => r.data),
  adminQuotes: () => client.get("/admin/quotes").then((r) => r.data),
};

export default client;
